import { BaseConfig } from '../ServiceConfig';

export interface FinanceConfiguration extends BaseConfig {
  '@type': 'type.googleapis.com/terra.v1.FinanceServiceConfigData';
  url: string;
}

export const FinanceConfigurationFields: (keyof FinanceConfiguration)[] = [
  'url',
];

export const BlankFinanceConfiguration: FinanceConfiguration = {
  '@type': 'type.googleapis.com/terra.v1.FinanceServiceConfigData',
} as FinanceConfiguration;
